import React, { useEffect, useState } from "react";
import clsx from "clsx";
import "./Faq.scss";
import "../Landing.scss";
import "../ln.scss";
import { withTranslation } from "react-i18next";
import axios from "axios";
import url from "../../../url.json";
import headers from "../../../config/headers";
import { Empty, Pagination } from "antd";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { Helmet } from "react-helmet-async";

function FaqLand({ t }) {
  const navigate = useNavigate();
  const [faqs, setFaqs] = useState();
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(1);
  const [openId, setOpenId] = useState(null);
  const [search, setSearch] = useState("");
  const lan = useSelector((state) => state.langReducer);

  useEffect(() => {
    setLoading(true);
    setOpenId(null);
    axios
      .get(url.url + `/faqs?page=${page}`, { headers: headers() })
      .then((res) => {
        setFaqs(res.data.data);
      })
      .catch((err) => {
        if (err.response?.status == 404) window.location = "/404";
        else toast.error(err.response?.data?.error || t("Something went wrong"));
      })
      .finally(() => setLoading(false));
  }, [lan.value, page]);

  const handlePage = (e) => {
    setPage(e);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const goContact = () => navigate("/#contact");

  const query = search.trim().toLowerCase();
  const items = (faqs?.result || []).filter(
    (res) =>
      !query ||
      res.question?.toLowerCase().includes(query) ||
      res.answer?.toLowerCase().includes(query)
  );
  const offset = ((faqs?.pagination?.current_page || 1) - 1) * (faqs?.pagination?.per_page || 0);

  return (
    <div className="landing-faq">
      <Helmet>
        <meta charSet="utf-8" />
        <title>Vis Nefrit | {t("FAQ")}</title>
      </Helmet>

      <div className="landing-faq__hero">
        <div className="landing-container">
          <span className="ln-eyebrow">{t("ln_ql_faq_text")}</span>
          <h1 className="landing-faq__title">{t("FAQ")}</h1>
          <p className="landing-faq__subtitle">{t("faq_subtitle")}</p>
          <div className="landing-faq__search">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden="true">
              <circle cx="11" cy="11" r="7" stroke="currentColor" strokeWidth="2" />
              <path d="M20 20l-3.5-3.5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
            </svg>
            <input
              type="search"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              placeholder={t("faq_search")}
            />
          </div>
        </div>
      </div>

      <div className="landing-container">
        <div className="landing-faq__list">
          {loading ? (
            [0, 1, 2].map((i) => <div key={i} className="faq-item faq-item_skeleton" />)
          ) : items.length ? (
            items.map((res, i) => {
              const opened = openId === res.id;
              return (
                <div key={res.id ?? i} className={clsx("faq-item", opened && "faq-item_open")}>
                  <button
                    type="button"
                    className="faq-item__head"
                    aria-expanded={opened}
                    onClick={() => setOpenId(opened ? null : res.id)}
                  >
                    <span className="faq-item__num">{offset + i + 1}</span>
                    <span className="faq-item__question">{res.question}</span>
                    <span className="faq-item__icon" aria-hidden="true" />
                  </button>
                  <div className="faq-item__body">
                    <div className="faq-item__inner">
                      <p className="faq-item__answer">{res.answer}</p>
                    </div>
                  </div>
                </div>
              );
            })
          ) : (
            <div className="landing-faq__empty">
              <Empty description={t("No data")} />
            </div>
          )}
        </div>

        {faqs?.pagination?.total_pages > 1 ? (
          <div className="landing-faq__pagin">
            <Pagination
              current={page}
              pageSize={faqs.pagination.per_page}
              total={faqs.pagination.total}
              showSizeChanger={false}
              onChange={handlePage}
            />
          </div>
        ) : (
          ""
        )}

        <div className="landing-faq__cta">
          <div>
            <h3 className="landing-faq__cta-title">{t("faq_cta_title")}</h3>
            <p className="landing-faq__cta-text">{t("faq_cta_text")}</p>
          </div>
          <button type="button" className="ln-btn ln-btn_primary" onClick={goContact}>
            {t("Contact us")}
          </button>
        </div>
      </div>
    </div>
  );
}
export default withTranslation()(FaqLand);
